export default "__VITE_ASSET__BCTTXF62__"